import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

const LookVirtualizedListLoadingItem = (props) => {

  const {style, currentType, lookExpanded} = props;

  return (
    <li className={"lm-feature lm-feature--type-" + currentType
      + (lookExpanded ? " lm-feature--expanded" : "")}
        style={style}>
      <div className="lm-feature__thumbnail">
        <div className="look-skeleton"/>
      </div>
      <div className="lm-feature__content">
        <div className="look-skeleton look-skeleton--name"/>
        {currentType === 1 ? (
          <div className="lm-feature__content-description">
            <div className="look-skeleton"/>
          </div>
        ) : null}
      </div>
    </li>
  )
};

LookVirtualizedListLoadingItem.propTypes = {
  style: PropTypes.object,
  viewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const mapStateToProps = (store, ownProps) => {
  const {lookExpanded, lookViewType} = store.lookState;
  const {isMobile} = store.serverState;
  const {viewType} = ownProps;

  return {
    lookExpanded,
    currentType: viewType || lookViewType,
    isMobile,
  };
};

export default connect(mapStateToProps)(LookVirtualizedListLoadingItem)
